module.exports = __webpack_public_path__ + "files/cc03a7a363852956d67d03d048a4b055.png";